import React, { useEffect, useState } from 'react';
import {
  Typography,
  Paper,
  Divider,
  TextField,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Box,
  CircularProgress
} from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import axios from '../../utils/axios';
import { useSnackbar } from 'notistack';

const Message = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [bots, setBots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');
  const [selected, setSelected] = useState([]); // массив bot._id

  // Загрузка ботов
  useEffect(() => {
    const loadBots = async () => {
      setLoading(true);
      try {
        const res = await axios.get('/telegram-bots');
        setBots(res.data || []);
      } catch (e) {
        enqueueSnackbar('Не удалось загрузить список ботов', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };
    loadBots();
  }, [enqueueSnackbar]);

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const isValid = message.trim().length > 0 && selected.length > 0;

  const handleSend = async () => {
    if (!isValid) {
      enqueueSnackbar('Введите сообщение и выберите хотя бы одного бота', { variant: 'warning' });
      return;
    }
    setSending(true);
    try {
      await Promise.all(
        selected.map((id) =>
          axios.post(`/telegram-bots/broadcast/${id}`, { message })
        )
      );
      enqueueSnackbar('Рассылка отправлена', { variant: 'success' });
      // при желании очищаем форму
      // setMessage('');
      // setSelected([]);
    } catch (e) {
      enqueueSnackbar('Ошибка при отправке рассылки', { variant: 'error' });
    } finally {
      setSending(false);
    }
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, backgroundColor: '#f4f6f8' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>Рассылка в Telegram</Typography>

      <TextField
        label="Текст сообщения"
        placeholder="Введите текст для рассылки"
        multiline
        minRows={5}
        fullWidth
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>Выберите ботов</Typography>
        <Typography variant="body2" color="text.secondary">
          Выбрано: {selected.length} / {bots.length}
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <List dense sx={{ bgcolor: '#fff', borderRadius: 1, boxShadow: 1 }}>
          {bots.map((bot) => {
            const labelId = `checkbox-list-label-${bot._id}`;
            const checked = selected.includes(bot._id);
            return (
              <ListItem
                key={bot._id}
                secondaryAction={null}
                onClick={() => toggleSelect(bot._id)}
                sx={{ cursor: 'pointer' }}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={checked}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemIcon>
                  <SmartToyIcon color={checked ? 'primary' : 'disabled'} />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={bot.username || 'Без имени'}
                  secondary={bot.settings?.commands ? `${bot.settings.commands.length} команд` : ' '}
                />
              </ListItem>
            );
          })}
          {bots.length === 0 && (
            <Box sx={{ p: 2 }}>
              <Typography color="text.secondary">Нет доступных ботов</Typography>
            </Box>
          )}
        </List>
      )}

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          onClick={() => setSelected(selected.length === bots.length ? [] : bots.map((b) => b._id))}
        >
          {selected.length === bots.length && bots.length > 0 ? 'Снять все' : 'Выбрать все'}
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          disabled={!isValid || sending}
          onClick={handleSend}
        >
          {sending ? 'Отправка...' : 'Отправить'}
        </Button>
      </Box>
    </Paper>
  );
};

export default Message;
